<script setup lang="ts">
import { PV, VR } from "@/components";
import { PrimeIcons } from "@primevue/core/api";
import { onErrorCaptured, onMounted } from "vue";

onMounted(async () => {
    document.body.removeAttribute("v-cloak");
});

onErrorCaptured((e) => {
    console.error(e);
});
</script>

<template>
    <VR.RouterView />
    <PV.Toast>
        <template #message="toastProps">
            <div class="flex flex-col items-start flex-auto">
                <div class="flex items-center gap-2">
                    <i :class="PrimeIcons.TIMES_CIRCLE" />
                    <span class="font-bold text-md">{{ toastProps.message.summary }}</span>
                </div>
                <div class="text-md">{{ toastProps.message.detail }}</div>
            </div>
        </template>
    </PV.Toast>
    <PV.Toast group="copy" position="bottom-center" />
</template>
